import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  
  Loja: "brokerbrasil",
  UserStorage: "x7xbsqtKJEeMOqKwSFjo7Q==",
  UserToken: "RU4QMy2Rnk2v6+U739Cr4A==",
  // UrlApi: "https://prd-ecommerce-bkb-api.primecase.com.br/api",
  UrlApi: "https://hlg-ecommerce-bkb-api.primecase.com.br/api",
  //UrlApi: "https://localhost:44388/api",
  UrlLoja:"https://hlg-ecommerce-bkb-web.primecase.com.br",
  //UrlLoja: "https://prd-ecommerce-bkb-web.primecase.com.br",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  //SecurityKey: "j3ZokW5mg9rsckOhi8E2",
  SecurityKey: "J189fODJ210F",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#066352",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("#066352", 10), // Escurece em 20%
    },
    secondary: {
      main: "#7E7296",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
